import { render, staticRenderFns } from "./BulkAssignRentPlan.vue?vue&type=template&id=035efc38&"
import script from "./BulkAssignRentPlan.vue?vue&type=script&lang=js&"
export * from "./BulkAssignRentPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports